// extracted by mini-css-extract-plugin
export default {"pageTitle":"schedule_pageTitle__okDe1","schedule":"schedule_schedule__MKpF5","box":"schedule_box__w8EIO","empty":"schedule_empty__bM0mZ"};